// removed by extract-text-webpack-plugin
module.exports = {"page":"wmf-xdHuBA9G","rowname":"wmf-1CEv6_k7","contents":"wmf-188p-i9d","required":"wmf-39iVzWgE","publicspan":"wmf-1_IZ7w3z","content":"wmf-2lV331tf"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/complaintinformationinquiry/complaint-information-inquiry.module.less
// module id = 1059
// module chunks = 0